import { makeRequest } from '@/libs/RequestModule'

/**
 * @param {string} type: info, error, etc
 * @param {string | Object} message
 * @param {boolean} skipConsole
 *
 * IMPORTANTE: Se a mensagem for ou contiver um objeto de erro, tem que passar como error.message ou error.stack.
 * Nunca o objeto error inteiro, porque o stringify no objeto error inteiro está causando perda de dados
 */
const log = ({ type = '', message = '', skipConsole = true }) => {
    makeRequest('log', { type, message, skipConsole })
        .catch(error => {
            return error.message
        })
}

/**
 * @param {string} type: info, error, etc
 * @param {string} route
 * @param {string | Object} requestMsg
 * @param {string | Object} responseMsg
 * @param {boolean} skipConsole
 *
 * IMPORTANTE: Se a mensagem for ou contiver um objeto de erro, tem que passar como error.message ou error.stack.
 * Nunca o objeto error inteiro, porque o stringify no objeto error inteiro está causando perda de dados
 */
const logCommunication = ({ type = '', route = '', requestMsg = '', responseMsg = '', skipConsole = true }) => {
    makeRequest('logCommunication', { type, route, requestMsg, responseMsg, skipConsole })
        .catch(error => {
            return error.message
        })
}

export { log, logCommunication }
